import React, { Component } from "react";
import Clock from "../components/Clock";
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import AuthService from "../../services/auth.service";

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #403f83;
    border-bottom: solid 1px #403f83;
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: rgba(255, 255, 255, .5);
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: block !important;
  }
  @media only screen and (max-width: 1199px) {
    .navbar{
      background: #403f83;
    }
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #fff;
    }
    .item-dropdown .dropdown a{
      color: #fff !important;
    }
  }
`;

export default class Createpage extends Component {

  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.state = {
      files: [],
      currentUser: undefined,
    };
  }

  authStatus() {
    let user = JSON.stringify(AuthService.getCurrentUser())
    console.log("user:" + user + " , " + this.state.currentUser)

    if (user) {
      this.setState({ currentUser: user })

    }
    else {
      window.location.replace("/login")
    }
  }

  componentDidMount() {

    this.authStatus();
  }

  onChange(e) {
    var files = e.target.files;
    console.log(files);
    var filesArr = Array.prototype.slice.call(files);
    console.log(filesArr);
    document.getElementById("file_name").style.display = "none";
    this.setState({ files: [...this.state.files, ...filesArr] });
  }

  render() {

    console.log("currentuser" + this.state.currentUser)

    return (
      <div>
        <GlobalStyles />
        {this.state.currentUser &&
          <>
            <section className='jumbotron breadcumb no-bg' style={{ backgroundImage: `url(${'./img/background/subheader.jpg'})` }}>
              <div className='mainbreadcumb'>
                <div className='container'>
                  <div className='row m-10-hor'>
                    <div className='col-12'>
                      <h1 className='text-center'>Create</h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className='container'>

              <div className="row">
                <div className="col-lg-7 offset-lg-1 mb-5">
                  <form id="form-create-item" className="form-border" action="#">
                    <div className="field-set">
                      <h5>Upload file</h5>

                      <div className="d-create-file">
                        <p id="file_name">PNG, JPG, GIF, WEBP or MP4. Max 200mb.</p>
                        {this.state.files.map(x =>
                          <p key="{index}">PNG, JPG, GIF, WEBP or MP4. Max 200mb.{x.name}</p>
                        )}
                        <div className='browse'>
                          <input type="button" id="get_file" className="btn-main" value="Browse" />
                          <input id='upload_file' type="file" multiple onChange={this.onChange} />
                        </div>

                      </div>

                      <div className="spacer-single"></div>

                      <h5>Title</h5>
                      <input type="text" name="item_title" id="item_title" className="form-control" placeholder="e.g. 'Crypto Funk" />

                      <div className="spacer-10"></div>

                      <h5>Description</h5>
                      <textarea data-autoresize name="item_desc" id="item_desc" className="form-control" placeholder="e.g. 'This is very limited item'"></textarea>

                      <div className="spacer-10"></div>

                      <h5>Price</h5>
                      <input type="text" name="item_price" id="item_price" className="form-control" placeholder="enter price for one item (ETH)" />

                      <div className="spacer-10"></div>

                      <h5>Royalties</h5>
                      <input type="text" name="item_royalties" id="item_royalties" className="form-control" placeholder="suggested: 0, 10%, 20%, 30%. Maximum is 70%" />

                      <div className="spacer-10"></div>

                      <input type="button" id="submit" className="btn-main" value="Create Item" />
                    </div>
                  </form>
                </div>

                <div className="col-lg-3 col-sm-6 col-xs-12">
                  <h5>Preview item</h5>
                  <div className="nft__item m-0">
                    <div className="de_countdown">
                      <Clock deadline="December, 30, 2021" />
                    </div>
                    <div className="author_list_pp">
                      <span>
                        <img className="lazy" src="./img/author/author-1.jpg" alt="" />
                        <i className="fa fa-check"></i>
                      </span>
                    </div>
                    <div className="nft__item_wrap">
                      <span>
                        <img src="./img/collections/coll-item-3.jpg" id="get_file_2" className="lazy nft__item_preview" alt="" />
                      </span>
                    </div>
                    <div className="nft__item_info">
                      <span >
                        <h4>Pinky Ocean</h4>
                      </span>
                      <div className="nft__item_price">
                        0.08 ETH<span>1/20</span>
                      </div>
                      <div className="nft__item_action">
                        <span>Place a bid</span>
                      </div>
                      <div className="nft__item_like">
                        <i className="fa fa-heart"></i><span>50</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </>
        }
        <Footer />
      </div>
    )
  };
}